import Iconfont from '@/components/iconfont/iconfont'
import { Column, Expaned, Row } from '@/components/layout/layout'
import { getFullImageurl, getVideoPreviewUrl } from '@/config/qiniu'
import { showLayer } from '@/utils/layer'
import { useDynamicList, useUpdateEffect } from 'ahooks'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import VideoPreview from './video-preivew'
import { Image } from 'antd'
import MediaPopover from './media-popover'
import useBemClass from '@/utils/hooks/useBEMClass'
import classname from 'classnames'
import { useScrollTo } from '@/utils/hooks/useScrollTo'
import MediaPreview from './media-preview'

interface MallMediaItem {
    $id: string
    content: string
}

interface MallMediaItemBigImage extends MallMediaItem {
    type: 'bigImage' | 'richText' | 'video'
}

interface MallMediaIteMutileImage {
    type: 'multiImage'
    $id: string
    content: Array<{
        $id: string
        url: string
    }>
}

export type MediaItemType = MallMediaIteMutileImage | MallMediaItemBigImage

interface MallMediaEditProps {
    val?: MediaItemType[]
    onChange?: (val: MediaItemType[]) => void
}

const MallMediaEdit: React.FC<MallMediaEditProps> = props => {
    const cls = useBemClass('media-edit')
    const { list: mediaList, push, remove, replace, resetList, move } = useDynamicList<MediaItemType>(
        props.val && props.val.length
            ? props.val
            : [
                  {
                      type: 'richText',
                      $id: new Date().getMilliseconds().toString() + Math.ceil(Math.random() * 100),
                      content: '',
                  },
              ],
    )
    const [expaned, setExpaned] = useState<boolean>(false)

    const getDesByType = useCallback((type: string) => {
        const typeMap: Record<string, string> = {
            richText: '文字',
            multiImage: '小图',
            bigImage: '大图',
            video: '视频',
        }

        return typeMap[type]
    }, [])

    useEffect(() => {
        if (props.val && props.val.length) resetList(props.val)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.val])

    useUpdateEffect(() => {
        props.onChange && props.onChange(mediaList)
    }, [mediaList])

    const mediaType = useMemo(() => {
        return [
            {
                text: '大图',
                icon: 'icondatu',
                click: (content: string) => {
                    push({
                        type: 'bigImage',
                        $id: new Date().getMilliseconds().toString() + Math.ceil(Math.random() * 100),
                        content,
                    })
                },
            },
            {
                text: '小图',
                icon: 'iconxiaotu',
                click: (content: string[]) => {
                    push({
                        type: 'multiImage',
                        $id: new Date().getMilliseconds().toString() + Math.ceil(Math.random() * 100),
                        content: content.map(l => ({
                            $id: new Date().getMilliseconds().toString() + Math.ceil(Math.random() * 100),
                            url: l,
                        })),
                    })
                },
            },
            {
                text: '视频',
                icon: 'iconshipin',
                click: (content: string) => {
                    push({
                        type: 'video',
                        $id: new Date().getMilliseconds().toString() + Math.ceil(Math.random() * 100),
                        content,
                    })
                },
            },
        ]
    }, [push])

    const scrollContainerRef = useRef<HTMLDivElement | null>(null)
    const { scrollToBottom } = useScrollTo(scrollContainerRef)

    return (
        <Column className={cls()}>
            <div
                className={cls('header')}
                style={{
                    borderBottom: '1px solid rgba(0,0,0,.1)',
                }}
            >
                <div data-font-size-14 data-color-999>
                    编辑图文描述
                </div>
                <Row data-align-items-center data-cursor-pointer>
                    <Row
                        data-align-items-center
                        onClick={() => {
                            showLayer(<MediaPreview val={mediaList} />)
                        }}
                    >
                        <i className="iconfont iconliulanliang" data-color-999 data-font-size-14 />
                        <div data-font-size-14 data-color-999 data-margin-left-8>
                            预览效果
                        </div>
                    </Row>
                    <div className="action" data-margin-left-16 onClick={() => setExpaned(v => !v)}>
                        {expaned ? '收起' : '展开'}
                    </div>
                </Row>
            </div>
            <div
                className={classname(cls('content'), cls('expaned-icon-all'))}
                ref={scrollContainerRef}
                style={{ maxHeight: expaned ? '1000px' : '220px' }}
            >
                {mediaList.map((me, index) => (
                    <Column key={me.$id}>
                        <Row className={cls('header')}>
                            <div data-font-size-16 data-color-000>
                                {getDesByType(me.type)}
                            </div>
                            <Row data-align-items-center>
                                <i
                                    className="iconfont iconxiangxia"
                                    data-font-size-24
                                    style={{
                                        cursor: index === mediaList.length - 1 ? 'not-allowed' : 'pointer',
                                        color: index === mediaList.length - 1 ? '#ddd' : '#999',
                                    }}
                                    onClick={() => {
                                        if (index === mediaList.length - 1) return
                                        move(index, index + 1)
                                    }}
                                />
                                <i
                                    className="iconfont iconxiangshang"
                                    data-margin-left-12
                                    data-font-size-24
                                    style={{
                                        cursor: index === 0 ? 'not-allowed' : 'pointer',
                                        color: index === 0 ? '#ddd' : '#999',
                                    }}
                                    onClick={() => {
                                        if (index === 0) return
                                        move(index, index - 1)
                                    }}
                                />
                                <i
                                    data-margin-left-12
                                    className="iconfont icon6lajixiang-20"
                                    data-font-size-26
                                    data-color-999
                                    data-cursor-pointer
                                    onClick={() => {
                                        remove(index)
                                    }}
                                />
                            </Row>
                        </Row>
                        <div className={cls('media-content')}>
                            {me.type === 'richText' && (
                                <textarea
                                    className={cls('rich-txt')}
                                    value={me.content}
                                    placeholder="请输入文字"
                                    onChange={e => {
                                        replace(index, {
                                            ...mediaList[index],
                                            type: 'richText',
                                            content: e.target.value,
                                        })
                                    }}
                                />
                            )}
                            {me.type === 'bigImage' && (
                                <Image className={cls('big-img')} alt="" src={getFullImageurl(me.content) + '?imageView2/2/w/800'} />
                            )}
                            {me.type === 'multiImage' && (
                                <>
                                    {me.content.map(c => (
                                        <Image
                                            key={c.$id}
                                            className={cls('small-img')}
                                            alt=""
                                            src={getFullImageurl(c.url) + '?imageView2/2/w/800'}
                                        />
                                    ))}
                                    {mediaList[index].content.length < 9 && (
                                        <MediaPopover
                                            onSuccess={list => {
                                                replace(index, {
                                                    ...mediaList[index],
                                                    type: 'multiImage',
                                                    content: (mediaList[index].content as any).concat(
                                                        list.map(l => ({
                                                            $id:
                                                                new Date().getMilliseconds().toString() +
                                                                Math.ceil(Math.random() * 100),
                                                            url: l,
                                                        })),
                                                    ),
                                                })
                                            }}
                                            maxCount={9 - mediaList[index].content.length}
                                            type="iconxiaotu"
                                        >
                                            <div className={classname('ant-image', cls('upload'))}>
                                                <div className={cls('upload-box')}>
                                                    <Iconfont name="icon6shangchuan-24" size={16} />
                                                    <div>素材库</div>
                                                </div>
                                            </div>
                                        </MediaPopover>
                                    )}
                                </>
                            )}
                            {me.type === 'video' && (
                                <div
                                    className={cls('big-img')}
                                    data-position-relative
                                    onClick={() => {
                                        showLayer(<VideoPreview url={me.content} />)
                                    }}
                                >
                                    <i className={`iconfont ${cls('play-icon')} iconshipin`} />
                                    <img data-height-100p data-width-100p alt="" src={getVideoPreviewUrl(me.content)} />
                                </div>
                            )}
                        </div>
                    </Column>
                ))}
            </div>
            <Row
                data-align-items-center
                style={{
                    height: '40px',
                    borderTop: '1px solid rgba(0,0,0,.1)',
                }}
            >
                <Expaned
                    data-center
                    data-row
                    data-cursor-pointer
                    onClick={() => {
                        scrollToBottom()
                        push({
                            type: 'richText',
                            $id: new Date().getMilliseconds().toString() + Math.ceil(Math.random() * 100),
                            content: '',
                        })
                    }}
                >
                    <Iconfont name="iconwenzi" size={16} />
                    <div data-font-size-14 data-margin-left-4>
                        文字
                    </div>
                </Expaned>
                {mediaType.map(media => (
                    <MediaPopover
                        expaned
                        onSuccess={list => {
                            if (media.icon === 'iconxiaotu') {
                                media.click(list as any)
                            } else {
                                media.click(list[0] as any)
                            }
                        }}
                        maxCount={9}
                        type={media.icon}
                        key={media.text}
                    >
                        <Expaned data-cursor-pointer data-center data-row>
                            <Iconfont name={media.icon} size={16} />
                            <div data-font-size-14 data-margin-left-4>
                                {media.text}
                            </div>
                        </Expaned>
                    </MediaPopover>
                ))}
            </Row>
        </Column>
    )
}

export default MallMediaEdit
